import React, { useRef, useEffect } from 'react';

export default function AltHero({
  videoSrc,
  posterSrc,
  headline        = 'Create. Enjoy. Share. Earn. All in One Place.',
  subhead         = 'Your content, your platform. Sell and earn in one place.',
  primaryLabel    = 'Get started',
  primaryHref     = '/',
  secondaryLabel  = 'See how it works',
  secondaryHref   = '#features',
  trustText       = 'Trusted by 2,000+ creators  ·  $2M paid out',
}) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoSrc) return;

    // Reduced-motion: never autoplay
    const prefersReduced =
      typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(video);
    return () => observer.disconnect();
  }, [videoSrc]);

  return (
    <section className="alt-hero" aria-label="Hero">

      {/* ── Background layer ───────────────────────────────── */}
      <div className="alt-hero__bg" aria-hidden="true">
        {videoSrc ? (
          <video
            ref={videoRef}
            className="alt-hero__video"
            muted
            loop
            playsInline
            preload="none"
            poster={posterSrc || undefined}
          >
            <source src={videoSrc} type="video/mp4" />
          </video>
        ) : posterSrc ? (
          <div
            className="alt-hero__poster"
            style={{ backgroundImage: `url(${posterSrc})` }}
          />
        ) : null}
        {/* Dark overlay always rendered */}
        <div className="alt-hero__overlay" />
      </div>

      {/* ── Solid black bottom bar ─────────────────────────── */}
      <div className="alt-hero__bottom">
        <div className="alt-hero__content alt-container">

          {/* Headline + subhead — left */}
          <div className="alt-hero__left">
            <h1 className="alt-hero__headline">{headline}</h1>
            {subhead && <p className="alt-hero__subhead">{subhead}</p>}
          </div>

          {/* CTAs + trust — right */}
          <div className="alt-hero__right">
            <div className="alt-hero__ctas">
              <a href={primaryHref}   className="alt-hero__btn-primary">
                {primaryLabel}
              </a>
              <a href={secondaryHref} className="alt-hero__btn-secondary">
                {secondaryLabel}
              </a>
            </div>
            {trustText && (
              <p className="alt-hero__trust">{trustText}</p>
            )}
          </div>

        </div>
      </div>

    </section>
  );
}
